import React from "react";
import './FooterLinks.css'
const FooterLinks = (props) => {
  return (
        <div className="circle">
      <img src={props.img} alt="footer icon" />
      </div>
  );
};

export default FooterLinks;